import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PartsOrder } from '@contracts/interfaces/parts-order.interface';

@Component({
  selector: 'app-task-complete-confirm-dialog',
  templateUrl: './task-complete-confirm.dialog.html',
  styleUrls: ['./task-complete-confirm.dialog.scss']
})
export class TaskCompleteConfirmDialog {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { taskId?: number | string; partsOrders: PartsOrder[] },
    private dialogRef: MatDialogRef<TaskCompleteConfirmDialog>
  ) { }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
